import config from "config";
import mixpanel, { Dict } from "mixpanel-browser";
import { ShopResponse } from "api/dtos/responses/ShopResponse";

export const Events = Object.freeze({
  source_tiktok: "source-tiktok",
  source_instagram: "source-instagram",
  onboard_step1_completed: "onboard-step1-completed",
  onboard_step2_completed: "onboard-step2-completed",
  onboard_step3_completed: "onboard-step3-completed",
  onboard_step4_completed: "onboard-step4-completed",
  onboard_step4_support: "onboard-step4-support",
  my_widgets_guidance_next: "my-widgets-guidance-next",
  my_widgets_guidance_skip: "my-widgets-guidance-skip",
  my_widgets_add_to_store: "my-widgets-add-to-store",
  add_to_store_theme_editor: "add-to-store-theme-editor",
  add_to_store_add_code: "add-to-store-add-code",
  add_to_store_auto_add: "add-to-store-auto-add",
  home_page_instagram_reels: "home-page-instagram-reels",
  Onboard_TikTok_Login: "Onboard-TikTok-Login",
  Onboard_Instagram_Login: "Onboard-Instagram-Login",
  TikTok_Login: "TikTok-Login",
  TikTok_Change_source: "TikTok-Change-source",
  TikTok_Input_hashtag: "TikTok-Input-hashtag",
  Instagram_Login: "Instagram-Login",
  Instagram_Change_source: "Instagram-Change-source",
  Instagram_Input_hashtag: "Instagram-Input-hashtag",
  My_widget_current_username_disable_TikTok:
    "My-widget-current-username-disable-TikTok",
  My_widget_current_username_disable_Instagram:
    "My-widget-current-username-disable-Instagram",
  onboard_posts_next: "onboard-posts-next",
  onboard_posts_back: "onboard-posts-back",
  onboard_step2_back: "onboard-step2-back",
  onboard_step3_back: "onboard-step3-back",
  onboard_step4_back: "onboard-step4-back",
  onboard_theme_page: "onboard-theme-page",
  pricing: "pricing",
  pricing_trial: "pricing-trial",
  pricing_promotion_code: "pricing-promotion-code"
});

type EventPanelType = (typeof Events)[keyof typeof Events];
export default class EventTrackingProvider {
  static Track = (event_name: EventPanelType, shop: ShopResponse) => {
    mixpanel.init(config.Tracing.MIXPANEL_API_Key);
    mixpanel.identify(shop.domain);
    mixpanel.people.set(this.SetConfig(shop));
    mixpanel.track(event_name);
  };

  static TrackWithContent = (
    event_name: EventPanelType | string,
    shop: ShopResponse,
    jsonContent: Object
  ) => {
    mixpanel.init(config.Tracing.MIXPANEL_API_Key);
    mixpanel.identify(shop.domain);
    mixpanel.people.set(this.SetConfig(shop));
    mixpanel.track(event_name, jsonContent);
  };

  static SetConfig = (shop: ShopResponse): Dict => {
    return {
      $name: shop.domain,
      $email: shop.email,
      $phone: shop?.phone,
      shopify_plan: shop?.planName,
      app_installation_status: "active"
    };
  };
}
